(() => {
  if (window.__mdVideoLoopInit) return;
  window.__mdVideoLoopInit = true;

  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const supportsFrames = 'requestVideoFrameCallback' in HTMLVideoElement.prototype;
  const LEAD = 0.08;

  function enhance(video) {
    if (video.dataset.mdSeamlessReady || reducedMotion.matches) return;
    video.dataset.mdSeamlessReady = 'true';

    const twin = video.cloneNode(true);
    twin.removeAttribute('autoplay');
    twin.removeAttribute('data-md-seamless');
    twin.dataset.mdSeamlessReady = 'true';
    twin.setAttribute('aria-hidden', 'true');
    twin.setAttribute('tabindex', '-1');
    twin.preload = 'auto';
    twin.muted = true;
    twin.loop = false;
    twin.classList.add('md-seamless', 'md-seamless--standby');
    video.classList.add('md-seamless');
    video.loop = false;
    video.after(twin);

    let active = video;
    let standby = twin;
    let swapping = false;

    function show(next, previous) {
      next.classList.remove('md-seamless--standby');
      previous.classList.add('md-seamless--standby');
      active = next;
      standby = previous;
      previous.pause();
      previous.currentTime = 0;
      swapping = false;
      watch(active);
    }

    function swap() {
      if (swapping) return;
      swapping = true;
      const previous = active;
      const next = standby;
      const played = next.play();
      const reveal = () => {
        if (supportsFrames) next.requestVideoFrameCallback(() => show(next, previous));
        else show(next, previous);
      };
      if (played && played.then) {
        played.then(reveal).catch(() => {
          swapping = false;
          previous.currentTime = 0;
          previous.play().catch(() => {});
        });
      } else {
        reveal();
      }
    }

    function watch(element) {
      if (!supportsFrames) return;
      const check = (now, metadata) => {
        if (element !== active || swapping) return;
        if (element.duration && metadata.mediaTime >= element.duration - LEAD) {
          swap();
          return;
        }
        element.requestVideoFrameCallback(check);
      };
      element.requestVideoFrameCallback(check);
    }

    [video, twin].forEach((element) => {
      element.addEventListener('ended', () => {
        if (element === active) swap();
      });
      if (!supportsFrames) {
        element.addEventListener('timeupdate', () => {
          if (element === active && element.duration && element.currentTime >= element.duration - 0.3) swap();
        });
      }
    });

    twin.addEventListener('loadeddata', () => {
      twin.currentTime = 0;
    });
    watch(active);
  }

  function init(root = document) {
    root.querySelectorAll('video[data-md-seamless]').forEach(enhance);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
